// Common dog breeds - alphabetized
export const dogBreeds = [
  'Afghan Hound',
  'Airedale Terrier',
  'Akita',
  'American Bulldog',
  'American Eskimo Dog',
  'American Staffordshire Terrier',
  'Australian Cattle Dog',
  'Australian Shepherd',
  'Basenji',
  'Basset Hound',
  'Beagle',
  'Belgian Malinois',
  'Bernese Mountain Dog',
  'Bichon Frise',
  'Bloodhound',
  'Border Collie',
  'Boston Terrier',
  'Boxer',
  'Brittany',
  'Bull Terrier',
  'Bulldog',
  'Bullmastiff',
  'Cairn Terrier',
  'Cane Corso',
  'Cavalier King Charles Spaniel',
  'Chihuahua',
  'Chinese Crested',
  'Chinese Shar-Pei',
  'Chow Chow',
  'Cocker Spaniel',
  'Collie',
  'Coonhound',
  'Corgi',
  'Dachshund',
  'Dalmatian',
  'Doberman Pinscher',
  'Dogo Argentino',
  'English Setter',
  'English Springer Spaniel',
  'Fox Terrier',
  'French Bulldog',
  'German Shepherd',
  'German Shorthaired Pointer',
  'Giant Schnauzer',
  'Golden Retriever',
  'Great Dane',
  'Great Pyrenees',
  'Greyhound',
  'Havanese',
  'Husky',
  'Irish Setter',
  'Irish Wolfhound',
  'Italian Greyhound',
  'Jack Russell Terrier',
  'Japanese Chin',
  'Labrador Retriever',
  'Lhasa Apso',
  'Maltese',
  'Mastiff',
  'Miniature Pinscher',
  'Miniature Schnauzer',
  'Mixed Breed',
  'Newfoundland',
  'Old English Sheepdog',
  'Papillon',
  'Pekingese',
  'Pit Bull',
  'Pointer',
  'Pomeranian',
  'Poodle',
  'Pug',
  'Rottweiler',
  'Saint Bernard',
  'Samoyed',
  'Schipperke',
  'Schnauzer',
  'Scottish Terrier',
  'Shetland Sheepdog',
  'Shiba Inu',
  'Shih Tzu',
  'Siberian Husky',
  'Staffordshire Bull Terrier',
  'Standard Schnauzer',
  'Vizsla',
  'Weimaraner',
  'Welsh Corgi',
  'West Highland White Terrier',
  'Whippet',
  'Yorkshire Terrier',
].sort();

// Common cat breeds - alphabetized
export const catBreeds = [
  'Abyssinian',
  'American Bobtail',
  'American Curl',
  'American Shorthair',
  'American Wirehair',
  'Balinese',
  'Bengal',
  'Birman',
  'Bombay',
  'British Shorthair',
  'Burmese',
  'Burmilla',
  'Chartreux',
  'Cornish Rex',
  'Devon Rex',
  'Domestic Long Hair',
  'Domestic Medium Hair',
  'Domestic Short Hair',
  'Egyptian Mau',
  'Exotic Shorthair',
  'Havana Brown',
  'Himalayan',
  'Japanese Bobtail',
  'Korat',
  'LaPerm',
  'Maine Coon',
  'Manx',
  'Mixed Breed',
  'Munchkin',
  'Norwegian Forest Cat',
  'Ocicat',
  'Oriental',
  'Persian',
  'Ragamuffin',
  'Ragdoll',
  'Russian Blue',
  'Scottish Fold',
  'Selkirk Rex',
  'Siamese',
  'Siberian',
  'Singapura',
  'Snowshoe',
  'Somali',
  'Sphynx',
  'Tonkinese',
  'Turkish Angora',
  'Turkish Van',
].sort();

export function getBreedsByAnimalType(animalType: string): string[] {
  return animalType?.toLowerCase() === 'dog' ? dogBreeds : catBreeds;
}
